import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMapPin, FiCamera, FiShield, FiStar, FiCheckCircle } = FiIcons;

const Space = () => {
  return (
    <div className="min-h-screen bg-white">
      <section className="py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-6xl font-extrabold text-gray-900 mb-6">
            Infraestrutura de <span className="text-blue-900">Estética Animal no Centro</span>
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto font-medium leading-relaxed">
            Conheça o espaço UniPET: o único centro de estética animal no Centro de JF projetado com padrões de higiene hospitalar e monitoramento constante.
          </p>
        </div>
      </section>

      <section className="py-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div initial={{ opacity: 0, scale: 0.98 }} animate={{ opacity: 1, scale: 1 }} className="relative aspect-video w-full bg-gray-100 rounded-[600px] overflow-hidden shadow-2xl mb-20 border-[12px] border-white ring-1 ring-gray-100">
           <img src="https://i.imgur.com/qmuoqj6.png" alt="Interior da UniPET" className="w-full h-full object-cover" />
           <div className="absolute bottom-10 left-10 bg-white/95 backdrop-blur px-8 py-6 rounded-3xl shadow-2xl border border-white hidden md:block">
              <div className="flex items-center gap-3 text-blue-900 font-black text-xl">
                <SafeIcon icon={FiMapPin} className="w-6 h-6" />
                <span>Rua Delfim Moreira, 125, Centro</span>
              </div>
              <p className="text-gray-500 mt-2 font-bold uppercase tracking-widest text-xs">O coração da estética pet em Juiz de Fora</p>
           </div>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-16 items-start mb-24">
          <div>
            <h2 className="text-3xl font-extrabold text-gray-900 mb-6">Inovação e Segurança</h2>
            <div className="prose prose-lg text-gray-600 font-medium">
              <p className="mb-4">
                O espaço da UniPET foi planejado pela <b>Dra. Luene Gomes</b> para integrar serviços estéticos de elite com segurança máxima. Nossa arquitetura favorece a ventilação e a desinfecção constante.
              </p>
              <p>
                Nosso centro foca no monitoramento constante e na separação rigorosa de áreas, garantindo que o seu pet esteja em um ambiente livre de contaminações e com baixo nível de ruído.
              </p>
            </div>
          </div>

          <div className="bg-blue-50/50 p-10 rounded-[40px] border border-blue-100">
            <h3 className="text-xl font-black text-blue-900 mb-8 uppercase tracking-[0.2em]">Diferenciais do Espaço:</h3>
            <ul className="space-y-6">
              {[
                "Toalhas esterilizadas individualmente",
                "Ambiente monitorado por câmeras",
                "Estações de banho ergonômicas e seguras",
                "Área de secagem com baixo ruído",
                "Produtos hospitalares para desinfecção"
              ].map((item, index) => (
                <li key={index} className="flex items-center gap-4 text-gray-800 font-bold">
                  <SafeIcon icon={FiCheckCircle} className="text-green-500 w-6 h-6 flex-shrink-0" />
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Space;